export default __webpack_public_path__ + "media/assets/images/edge-7c5fdb5038614094f1ee93e8dc2f491a.png";